var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-items-center justify-content-center mt-5 mb-5"},[_c('div',{staticClass:"row"},[_c('b-spinner',{staticStyle:{"width":"3rem","height":"3rem"},attrs:{"type":"grow"}})],1),(_vm.text)?_c('div',{staticClass:"row"},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }